import {useQuery} from '@tanstack/react-query';

import {getCountries, getLocationsByCountry} from '../services/countryService';
import {Country} from '../types/geolocations';

/**
 * Hook para obtener la lista de países
 * @returns Lista de países
 */
export function useCountries() {
  return useQuery<Country[]>({
    queryKey: ['countries'],
    queryFn: getCountries,
  });
}

/**
 * Hook para obtener locations filtradas por país
 * @param idCountry - ID del país
 * @param idOrganization - ID de la organización
 * @returns Lista de locations del país
 */
export function useLocationsByCountry(
  idCountry: number | undefined,
  idOrganization?: string,
) {
  const query = useQuery({
    queryKey: ['locations-by-country', idCountry, idOrganization],
    queryFn: async () => {
      if (!idCountry) {
        return [];
      }
      return getLocationsByCountry(idCountry, idOrganization);
    },
    enabled: !!idCountry,
  });

  return {
    ...query,
    data: query.data || [],
  };
}
